import { Action, createReducer, on } from '@ngrx/store';

import * as activitiesActions from '@activities/activities-results/store/actions/activities-results.actions';
import * as autosDetailActions from '@autos/auto-detail/store/actions/auto.actions';
import { searchErrorAction } from '@app/store/actions/global.actions';
import * as hotelsDetailActions from '@hotels/hotel-detail/store/actions/hotels.actions';

export const initialState = true;

const featureReducer = createReducer(
  initialState,
  on(
    hotelsDetailActions.fetchHotelDetailAction,
    hotelsDetailActions.fetchHotelDetailDeeplinkAction,
    hotelsDetailActions.fetchHotelDetailPackageAction,
    hotelsDetailActions.fetchHotelDetailByCodePackageAction,
    autosDetailActions.fetchAutoDetailAction,
    autosDetailActions.fetchAutoAgenciesAction,
    activitiesActions.fetchActivitiesDetailAction,
    () => initialState
  ),
  on(
    searchErrorAction,
    hotelsDetailActions.fetchHotelDetailSuccessAction,
    hotelsDetailActions.fetchHotelDetailDeeplinkErrorAction,
    hotelsDetailActions.fetchHotelDetailDeeplinkSuccessAction,
    hotelsDetailActions.fetchHotelDetailByCodePackageSuccessAction,
    hotelsDetailActions.fetchHotelDetailPackageSuccessAction,
    autosDetailActions.fetchAutoDetailSuccessAction,
    autosDetailActions.fetchAutoDetailErrorAction,
    autosDetailActions.fetchAutoAgenciesSuccessAction,
    activitiesActions.fetchActivitiesDetailSuccessAction,
    () => false
  ),
);

export const isLoadingResultsDetailReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};
